import React, { useState, useEffect } from "react";
import ProjectRow from "./ProjectRow";
import config from "../../config";

const ProjectList = () => {
  const [projects, setProjects] = useState([]);

  const fetchProjects = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/api/getProjectsAd`); // Remplacer par ton URL
      if (!response.ok) {
        throw new Error(`Erreur HTTP : ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setProjects(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des projets :", error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []); // Charge les projets au montage

  const handleDelete = async (projectToDelete) => {
    console.log("project.id:", projectToDelete.id);

    try {
      const response = await fetch(
        `${config.API_BASE_URL}/api/projects/${projectToDelete.id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error(`Erreur HTTP : ${response.status}`);
      }

      setProjects((prevProjects) =>
        prevProjects.filter((proj) => proj.id !== projectToDelete.id)
      );
    } catch (error) {
      console.error("Erreur lors de la suppression du projet :", error);
    }
  };

  return (
    <div className="w-full space-y-6 mt-10">
      <div className="bg-light p-6 rounded-xl shadow-md overflow-x-auto">
        <table className="w-full table-auto text-left border-collapse">
          <thead>
            <tr className="bg-accent text-white ">
              <th className="px-6 py-3">Titre</th>
              <th className="px-6 py-3">Catégorie</th>
              <th className="px-6 py-3">Description</th>
              <th className="px-6 py-3">Images</th>
              <th className="px-6 py-3">Créé le</th>
              <th className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((proj) => (
              <ProjectRow
                key={proj.id}
                project={proj}
                onDelete={handleDelete}
                onUpdate={fetchProjects}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectList;
